
import { Component, Vue, Prop, Ref, Mixins } from "vue-property-decorator";

import Post from '@/models/Post';

import PostTypology from '@/components/Post/Typology.vue';
import ExpandableText from '@/components/Common/ExpandableText.vue';
import LikeButton from '@/components/Like/Button.vue';
import VSvg from '@/components/Common/VSvg.vue';
import { currentUserStore } from "@/store/typed";
import { safeAsync } from "@/utils/AsyncUtil";
import PostMixin from "@/mixins/http/PostMixin";
import { showErrorToast } from "@/utils/Toast";
import FileDownloader from '@/components/Common/FileDownloader.vue';
import PostLink from '@/components/Post/Link.vue';
import PostContactModal from '@/components/Post/ContactModal.vue';

@Component({
  components: {
    PostTypology,
    ExpandableText,
    LikeButton,
    VSvg,
    FileDownloader,
    PostLink,
    PostContactModal
  }
})
export default class PostItem extends Mixins(PostMixin) {
  @Prop({ required: true }) readonly value!: Post;
  @Ref() postContactModal!: PostContactModal;

  get isMobile() {
    return this.$mq === 'sm';
  }

  get ownPost() {
    return currentUserStore.user.organization?.id === this.value.initiative.organization?.id;
  }

  get disabled() {
    return currentUserStore.user?.isOccUser || currentUserStore.user?.isConsipUser;
  }

  filename(url: string) {
    const split = url.split('/')
    return unescape(split[split.length-1]);
  }

  private async deletePost() {
    const [data, errors] = await safeAsync(this.destroyPost(this.value.id));

    if (errors) {
      showErrorToast('Sì è verificato un problema con la cancellazione del post.');
      return;
    }

    this.$emit('delete');
  }

  private openContactModal() {
    this.postContactModal.show();
  }
}
